import { parseCookies } from 'nookies';

export const addBranchToOrderUrlPath = (urlPath: string) => {
  const domain =
    typeof window !== 'undefined'
      ? window.location.host
      : process.env.SERVER_HOST || 'platform.empirie.dev';
  if (domain.includes('localhost') || domain.includes('.dev') || domain.includes('emma.lan')) {
    const orderCookie = parseCookies()['feature-backend-checkout'];
    if (orderCookie && orderCookie.length > 0 && orderCookie !== 'master') {
      return urlPath.replace('/api/', `/api/feature/${orderCookie}/`);
    }
  }
  return urlPath;
};
